module.exports = __webpack_public_path__ + "static/img/ckeditor4.150111b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ckeditor4.png
// module id = jua8
// module chunks = 0